<template>
  <div class="app-container complaint-type">
    <el-card class="box-card">
      <div class="page-title">反馈类型配置</div>
      <div class="btn-box mb10">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleCreate" v-hasPermi="['complaint:type:edit']">新增类型</el-button>
        <el-button type="primary" size="mini" plain icon="el-icon-document-checked" @click="handleSaveOrder" v-hasPermi="['complaint:type:edit']">保存排序</el-button>
      </div>
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="类型名称：">
            <el-input v-model="query.typeName" placeholder="请输入类型名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="启用状态：">
            <el-select v-model="query.enabled" placeholder="全部状态" clearable size="small">
              <el-option label="全部状态" :value="undefined"></el-option>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="停用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="handleQuery">查询</el-button>
            <el-button type="info" size="mini" plain @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table v-loading="listLoading" :data="list">
        <el-table-column label="类型名称" prop="typeName" align="center" width="130" />
        <el-table-column label="类型说明" prop="typeDesc" align="center" min-width="220" show-overflow-tooltip />
        <el-table-column label="适用端" prop="applyEnd" align="center" width="100" />
        <el-table-column label="默认处理部门" prop="defaultDeptName" align="center" width="130" />
        <el-table-column label="处理时限" align="center" width="100">
          <template slot-scope="{row}">{{row.handleHours ? row.handleHours + '小时' : ''}}</template>
        </el-table-column>
        <el-table-column label="排序" align="center" width="110">
          <template slot-scope="{row}">
            <!-- 就地改排序，改完点上方【保存排序】一次性提交 -->
            <el-input-number v-model="row.orderNo" size="mini" controls-position="right" :min="0" style="width: 90px" />
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="90">
          <template slot-scope="{row}">
            <el-tag size="mini" :type="+row.enabled === 1 ? 'success' : 'info'">{{+row.enabled === 1 ? '启用' : '停用'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="240" fixed="right">
          <template slot-scope="{row, $index}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['complaint:type:edit']">编辑</el-button>
            <el-button type="text" @click="handleDelete(row)" v-hasPermi="['complaint:type:edit']">删除</el-button>
            <el-button type="text" @click="handleSetEnabled(row)" v-hasPermi="['complaint:type:edit']">{{+row.enabled === 1 ? '停用' : '启用'}}</el-button>
            <el-button type="text" :disabled="$index === 0" @click="handleMove(row, 'up')" v-hasPermi="['complaint:type:edit']">上移</el-button>
            <el-button type="text" :disabled="$index === list.length - 1" @click="handleMove(row, 'down')" v-hasPermi="['complaint:type:edit']">下移</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      <div class="foot-tip">
        <i class="el-icon-info"></i> 反馈类型将同步至 APP 客诉反馈下拉选项
      </div>
    </el-card>

    <complaint-type-add ref="complaintTypeAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import customerComplaintTypeApi from '@/api/complaint/customerComplaintType'
import ComplaintTypeAdd from './add.vue'

function initQuery() {
  return {
    pageNo: 1,
    pageSize: 10,
    typeName: undefined,
    enabled: undefined
  }
}

export default {
  name: 'ComplaintType',
  components: { Pagination, ComplaintTypeAdd },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      query: initQuery()
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    handleReset() {
      this.query = initQuery()
      this.doQueryList({ pageNo: 1 })
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize
      this.listLoading = true
      return customerComplaintTypeApi.fetchList(this.query)
        .then(data => {
          this.list = (data.data && data.data.list) || []
          this.total = (data.data && data.data.total) || 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleCreate() {
      this.$refs.complaintTypeAdd.handleCreate()
    },
    handleUpdate(row) {
      this.$refs.complaintTypeAdd.handleUpdate(row)
    },
    handleDelete(row) {
      return this.$common.confirm('是否确认删除该反馈类型？')
        .then(() => customerComplaintTypeApi.deleteById(row.id))
        .then(() => {
          this.$message.success('删除成功')
          return this.doQueryList({})
        })
        .catch(() => {})
    },
    handleSetEnabled(row) {
      const enabled = +row.enabled === 1 ? 0 : 1
      return customerComplaintTypeApi.setEnabled({ id: row.id, enabled })
        .then(() => {
          this.$message.success('操作成功')
          return this.doQueryList({})
        })
    },
    handleMove(row, direction) {
      return customerComplaintTypeApi.move({ id: row.id, direction })
        .then(() => this.doQueryList({}))
    },
    handleSaveOrder() {
      const list = this.list.map(row => ({ id: row.id, orderNo: row.orderNo }))
      if (!list.length) {
        this.$common.showMsg('warning', '暂无可保存的数据')
        return
      }
      return customerComplaintTypeApi.saveOrder(list)
        .then(() => {
          this.$message.success('排序保存成功')
          return this.doQueryList({})
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.complaint-type {
  .page-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
  }
  .foot-tip {
    margin-top: 10px;
    font-size: 13px;
    color: #409eff;
  }
}
</style>
